import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useModals } from "@/context/ModalContext";
import { api } from "@/lib/api";
import { GOOGLE_MEET_LINK, PHONE, PHONE_HREF } from "@/lib/config";
import { Calendar, Check, Phone, Truck } from "lucide-react";
import { toast } from "sonner";

const field = "w-full bg-charcoal border border-white/15 px-3 py-2.5 text-sm text-cream outline-none focus:border-gold placeholder:text-cream/40";

export const WhiteGloveModal = () => {
  const { whiteGlove, closeWhiteGlove } = useModals();
  const [done, setDone] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", phone: "" });
  const open = !!whiteGlove;
  const product = whiteGlove?.product;

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.postWhiteGlove({ ...form, productId: product?.id, productName: product?.title });
      setDone(true);
    } catch (e) { toast.error("Something went wrong."); }
  };
  const close = () => { closeWhiteGlove(); setTimeout(() => { setDone(false); setForm({ name: "", email: "", phone: "" }); }, 300); };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent data-testid="white-glove-modal" aria-describedby={undefined} className="bg-espresso border-white/10 text-cream sm:max-w-md">
        {!done ? (
          <>
            <DialogHeader>
              <DialogTitle className="font-serif text-2xl text-cream flex items-center gap-2">
                <Truck className="text-gold" size={22} /> White Glove Delivery
              </DialogTitle>
            </DialogHeader>
            <DialogDescription className="text-cream/60 text-sm -mt-1">
              Request premium delivery & installation{product ? ` for the ${product.title}` : ""}. Our team will arrange every detail.
            </DialogDescription>
            <form onSubmit={submit} className="space-y-3 mt-2">
              <input data-testid="wg-name" required placeholder="Full name" className={field}
                value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              <input data-testid="wg-email" required type="email" placeholder="Email" className={field}
                value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              <input data-testid="wg-phone" required placeholder="Phone" className={field}
                value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
              {product && <input readOnly value={product.title} className={field + " opacity-70"} />}
              <button data-testid="wg-submit" type="submit"
                className="w-full bg-gold text-espresso py-3 font-medium hover:bg-amber transition-colors">Request White Glove Delivery</button>
            </form>
          </>
        ) : (
          <div className="text-center py-4" data-testid="wg-success">
            <div className="w-14 h-14 rounded-full bg-forest/20 flex items-center justify-center mx-auto mb-4">
              <Check className="text-forest" size={28} />
            </div>
            <h3 className="font-serif text-2xl">Request received.</h3>
            <p className="text-cream/65 text-sm mt-2">Our delivery concierge will contact you shortly. Prefer to talk now? Book a call below.</p>
            <a href={GOOGLE_MEET_LINK} target="_blank" rel="noreferrer" data-testid="wg-book-link"
              className="mt-5 inline-flex items-center gap-2 bg-gold text-espresso px-6 py-3 font-medium hover:bg-amber transition-colors">
              <Calendar size={18} /> Book a Call
            </a>
            <a href={PHONE_HREF} className="mt-3 flex items-center justify-center gap-2 text-cream/70 hover:text-gold text-sm">
              <Phone size={14} /> Or call {PHONE}
            </a>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
